import script from "./EditProductModal.vue?vue&type=script&setup=true&lang=js"
export * from "./EditProductModal.vue?vue&type=script&setup=true&lang=js"

import "./EditProductModal.vue?vue&type=style&index=0&id=d35c0b50&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d35c0b50"]])

export default __exports__